import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import {
  Button,
  Divider,
  Image,
  Icon,
  Header,
  Modal,
  Grid,
  Table,
  Segment,
} from 'semantic-ui-react';

import ReactPlayer from 'react-player';

import { DyzioModalHeader } from 'dyzio-shared-components/lib/components/dyzio-modal';

import hasRESTClient from '../../hocs/has-rest-client';

const modalImageStyle = {
  maxHeight: 500,
  minHeight: 500,
  display: 'block',
  margin: '0 auto',
  maxWidth: '100%',
};

const loaderStyle = {
  maxHeight: 500,
  minHeight: 500,
  textAlign: 'center',
  paddingTop: 190,
  color: '#555',
};

class StoryPickerModal extends React.Component {
  //
  constructor() {
    super();
    this.state = {
      isLoading: true,
      isError: false,
      stories: [],
      currentStoryIndex: 0,
    };
  }

  async componentDidMount() {
    const { influencerId, buildRESTClient } = this.props;
    const restClient = buildRESTClient({
      baseURL: process.env.REACT_APP_STORY_SERVICE_API,
    });
    const response = await restClient.get(`stories/by-influencer/${influencerId}`);
    if (response) {
      const stories = _.get(response, 'data.data', []);
      this.setState({
        isLoading: false,
        isError: false,
        stories,
      });
    }
  }

  changeActiveStoryIndex = direction => {
    const { currentStoryIndex } = this.state;
    if (direction === 'down') {
      this.setState({
        currentStoryIndex: _.subtract(currentStoryIndex, 1),
      });
    } else {
      this.setState({
        currentStoryIndex: _.add(currentStoryIndex, 1),
      });
    }
  }

  render() {
    const { isLoading, isError, stories, currentStoryIndex } = this.state;
    const { onClose, existingStoriesIDs, onAddStoryToCollaboration, isAddingStoryToCollab } = this.props;
    const renderedStory = _.nth(stories, currentStoryIndex);
    const isVideo = _.get(renderedStory, 'media_type') === 'VIDEO';
    const hasMediaURL = _.has(renderedStory, 'media_url');

    const isAlreadyAdded = _.includes(existingStoriesIDs, _.get(renderedStory, 'shortcode'));

    return (
      <Modal
        open
        size="tiny"
        onClose={onClose}
        closeOnEscape
        closeOnDimmerClick
      >
        <DyzioModalHeader headerText="Stories" onClose={onClose} />
        <Modal.Content>
          {
            isLoading && (
              <Segment style={loaderStyle} >
                <Header icon>
                  <Icon name="refresh" loading />
                  Loading stories
                </Header>
              </Segment>
            )
          }
          {
            !isLoading && !isError && _.isEmpty(stories) && (
              <Segment style={loaderStyle} >
                <Header icon>
                  <Icon name="circle" />
                  No live stories found
                </Header>
              </Segment>
            )
          }
          {
            !isLoading && !isError && renderedStory &&
            <div>
              <Grid>
                <Grid.Row>
                  <Grid.Column width="8">
                    {
                      !isVideo &&
                      <Image
                        style={modalImageStyle}
                        src={_.get(renderedStory, 'media_url')}
                      />
                    }
                    {
                      isVideo && hasMediaURL &&
                      <ReactPlayer
                        controls
                        style={modalImageStyle}
                        url={_.get(renderedStory, 'media_url')}
                      />
                    }
                    {
                      isVideo && !hasMediaURL &&
                      <Image
                        style={modalImageStyle}
                        src={_.get(renderedStory, 'thumbnail_url')}
                      />
                    }
                  </Grid.Column>
                  <Grid.Column width="8">
                    <Button
                      onClick={() => onAddStoryToCollaboration(renderedStory)}
                      icon
                      labelPosition="right"
                      fluid
                      color={isAlreadyAdded ? 'gray' : 'pink'}
                      disabled={isAlreadyAdded || isAddingStoryToCollab}
                    >
                      { isAlreadyAdded ? 'Already added' : 'Add to collaboration' }
                      <Icon name={isAlreadyAdded ? 'checkmark' : 'add'} />
                    </Button>
                    <Table basic="very">
                      <Table.Row>
                        <Table.Cell>
                      type
                        </Table.Cell>
                        <Table.Cell>
                          { _.get(renderedStory, 'media_type', '-') }
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                      posted
                        </Table.Cell>
                        <Table.Cell>
                          { moment(_.get(renderedStory, 'timestamp')).format('lll') }
                        </Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell>
                      expires
                        </Table.Cell>
                        <Table.Cell>
                          { moment(_.get(renderedStory, 'timestamp')).add('hours', 24).format('lll') }
                        </Table.Cell>
                      </Table.Row>
                    </Table>
                    <Divider />
                    <h4>Caption:</h4>
                    <Divider hidden fitted />
                    { _.get(renderedStory, 'caption', 'No caption') }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider />
              <Grid verticalAlign="middle">
                <Grid.Row>
                  <Grid.Column width="4">
                    <Button
                      icon
                      labelPosition="left"
                      inverted
                      color="green" disabled={currentStoryIndex === 0}
                      onClick={() => this.changeActiveStoryIndex('down')}
                    >
                      <Icon name="left arrow" />
                        Previous
                    </Button>
                  </Grid.Column>
                  <Grid.Column width="8" textAlign="center">
                Story {currentStoryIndex + 1} of {_.size(stories)}
                  </Grid.Column>
                  <Grid.Column width="4" textAlign="right">
                    <Button
                      icon
                      labelPosition="right"
                      inverted
                      color="green"
                      disabled={_.add(1, currentStoryIndex) === _.size(stories)}
                      onClick={() => this.changeActiveStoryIndex('up')}
                    >
                      Next
                      <Icon name="right arrow" />
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          }

        </Modal.Content>
      </Modal>
    );
  }
}

StoryPickerModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  influencerId: PropTypes.string.isRequired,
  onAddStoryToCollaboration: PropTypes.func.isRequired,
  existingStoriesIDs: PropTypes.array,
  isAddingStoryToCollab: PropTypes.bool.isRequired,
};

StoryPickerModal.defaultProps = {
  existingStoriesIDs: [],
};

export default hasRESTClient(StoryPickerModal);



/** WEBPACK FOOTER **
 ** ./src/containers/story-picker-modal/index.js
 **/